import { guideIconHtml } from "@scalar-org/guide-icons";
import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
const guideCardHtml = async (props) => {
  const titleHtml = props.title ? html`<p class="card-title">${props.title}</p>` : "";
  const cardIconClasses = [EditorClasses.Icon];
  const iconContentHtml = props.icon && props.title ? `${await guideIconHtml({ src: props.icon, classes: cardIconClasses })} ${titleHtml}` : props.icon ? await guideIconHtml({ src: props.icon, classes: cardIconClasses }) : props.title ? titleHtml : "";
  const leftIconHtml = await guideIconHtml({
    src: props.leftIcon,
    classes: cardIconClasses
  });
  const cardContent = html`
    <div class="card-content">
      <div data-scalar-name="card-icon" class="card-content__icon">
        ${iconContentHtml}
      </div>
      <div class="card-content__text">
        <ssg-children></ssg-children>
      </div>
    </div>
  `;
  return html`
    <div class="card ${EditorClasses.Card}">
      ${leftIconHtml}
      ${cardContent}
    </div>
  `;
};
export {
  guideCardHtml
};
//# sourceMappingURL=component.js.map
